<template>
    <div class="card mb-2">
        <div class="card-header">
            <div class="collapsed card-link" data-parent="#accordion">
                Információk
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="device-type">Készülék típus*</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <v-select
                                id="device-type"
                                :options="deviceTypeOptions"
                                v-model="worksheet.deviceType"
                                taggable
                                push-tags
                                :disabled="disabled"
                            >
                                <div slot="no-options">Új típus megadásához gépelje be, majd üssön ENTER-t.</div>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="colors-number">Colors sorozatszám*</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input
                                id="colors-number"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="worksheet.colorsNumber"
                                :readonly="disabled"
                            >
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="device-user">Készülékhez tartozó felhasználónév</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input
                                id="device-user"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="worksheet.deviceUser"
                                :readonly="disabled"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="device-password">Készülékhez tartozó jelszó</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input
                                id="device-password"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="worksheet.devicePassword"
                                :readonly="disabled"
                            >
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="estimated-time">Várható elkészülés</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input
                                id="estimated-time"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="worksheet.estimatedTime"
                                :readonly="disabled"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-3">
                    <div class="form-check">
                        <label class="form-check-label" style="margin-top: 35px;">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.notification"
                                :disabled="disabled"
                            >
                            Értesítést kér?
                        </label>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-3">
                    <div class="form-group" stlye="inline-block">
                        <label for="estimated-price">Várható költség</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input
                                id="estimated-price"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="worksheet.estimatedPrice"
                                :readonly="disabled"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-3">
                    <div class="form-check">
                        <label class="form-check-label" style="margin-top: 35px;">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.priceOffer"
                                :disabled="disabled"
                            >
                            Árajánlat a költségekről?
                        </label>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="form-group">
                        <label for="comment">Hibajelenség leírása</label>
                        <textarea
                            class="form-control"
                            rows="3"
                            id="comment"
                            style="resize: none;"
                            v-model="worksheet.comment"
                            :readonly="disabled"
                        ></textarea>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="form-group">
                        <label for="extraInfo">Kiegészítő információk</label>
                        <textarea
                            class="form-control"
                            rows="3"
                            id="extraInfo"
                            style="resize: none;"
                            v-model="worksheet.extraInfo"
                            placeholder="Pl: leadott tartozékok, előleg, árajánlat sorszám stb."
                            :readonly="disabled"
                        ></textarea>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.dust"
                                :disabled="disabled"
                            >
                            Portalanítás
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.datasave"
                                :disabled="disabled"
                            >
                            Adatmentés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.durability"
                                :disabled="disabled"
                            >
                            Állóképesség
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.testing"
                                :disabled="disabled"
                            >
                            Tesztelés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.antivirus"
                                :disabled="disabled"
                            >
                            Vírus és kém írtás
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.installMini"
                                :disabled="disabled"
                            >
                            Telepítés MINI
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.installBasic"
                                :disabled="disabled"
                            >
                            Telepítés ALAP
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.cabel"
                                :disabled="disabled"
                            >
                            Kábelezés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.performance"
                                :disabled="disabled"
                            >
                            Összeszerelés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.internet"
                                :disabled="disabled"
                            >
                            Internet probléma
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.antivirusExpired"
                                :disabled="disabled"
                            >
                            Vírusírtó lejárt
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.update"
                                :disabled="disabled"
                            >
                            Általános frissítés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.notStarting"
                                :disabled="disabled"
                            >
                            Nem indul el
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.switching"
                                :disabled="disabled"
                            >
                            Beépítés csere
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.burnt"
                                :disabled="disabled"
                            >
                            (el)Füstölt
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.reinstall"
                                :disabled="disabled"
                            >
                            Újratelepíteni
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.firmware"
                                :disabled="disabled"
                            >
                            Firmware frissítés
                        </label>
                    </div>
                </div>
                <div class="col-lg-4 col-xl-2">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="worksheet.extra.maintance"
                                :disabled="disabled"
                            >
                            Karbantartás
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Information',
        data(){
            return {
                deviceTypeOptions: []
            }
        },
        props: {
            worksheet: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            loadDevieTypes(){
                this.$store.dispatch('HelperModul/getDeviceTypes', {
                    result: (res) => {
                        if(res !== 'NO_DATA'){
                            this.deviceTypeOptions = [];
                            res.deviceTypeList.forEach(item => {
                                this.deviceTypeOptions.push(item.device_type);
                            });
                        }
                    },
                    reject: (rej) => {
                        console.error(rej);
                    }
                });
            }
        },
        mounted(){
            this.loadDevieTypes();
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/worksheet/Informations.vue